<template>
    <div class="wrap">
        <qk_head></qk_head>
        <router-view></router-view>
        <footer_index></footer_index>
    </div>
</template>

<script>
    import qk_head from "./qk_head"
    import footer_index from "../home/footer_index"
    export default {
        name: "index",
        components:{
            qk_head,
            footer_index
        }
    }
</script>

<style scoped>
    .wrap {
        min-height: 100%;
        display: flex;
        flex-direction: column;
    }
</style>
